import React from 'react';

import { TextBlockProps } from '@/app/_blocks/TextBlockGraphQL/types';

import classes from './TextBlock.module.scss';
import { DebugJsonBlock } from '../DebugJsonBlock';
import { Gutter } from '../Gutter';
import { SemanticHeading } from '../SemanticHeading';
import { renderTrademarkText } from '../TrademarkText';

export const TextBlock: React.FC<{
  className?: string;
  textBlock: TextBlockProps;
}> = ({ className, textBlock }) => {
  // const blockData = Object.keys(textBlock).reduce((acc, key) => {
  //   acc[key] = textBlock[key].clone();
  //   return acc;
  // }, {});
  return (
    <Gutter>
      <div className={[className, classes.wrapper, 'grid'].filter(Boolean).join(' ')}>
        <div className="col-6 col-sm-12">
          <SemanticHeading 
            heading={textBlock.semanticTitle}
            fallbackText={textBlock.title_legacy}
            fallbackTag="h2"
          />
        </div>
        <div className="col-6 col-sm-12">
          <p>{textBlock.description ? renderTrademarkText(textBlock.description) : null}</p>
        </div>
        <DebugJsonBlock block={{ ...textBlock }} />
      </div>
    </Gutter>
  );
};

export default TextBlock;
